
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'DeviationCrewTypeInput',

  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const model = ref(props.modelValue)

    watch(model, (value) => {
      emit('update:modelValue', value)
    })

    return {
      model,
    }
  },
})
